/**
 * 보드 위 숫자 네 칸(2026-10-18 C 현황판형).
 *
 * **지금 보고 있는 목록에서 센다** — 필터를 걸면 숫자도 함께 줄어든다.
 * 서버에 따로 묻지 않는 이유는 둘이다: 보드와 숫자가 어긋나면 안 되고,
 * 쓰는 사람이 셋이라 프로젝트 전체 목록이 이미 한 번에 내려온다.
 *
 * 「마감 지남」은 카드의 `DueMark` 와 **같은 날짜 기준**을 쓴다 — 둘이 다르면
 * 카드는 빨간데 숫자는 0 인 날이 생긴다. 완료 칸은 세지 않는다.
 */

import type { TicketCard } from '../api';

/** 이번 주 월요일 0시(브라우저 시간대). */
function weekStart(now: Date): Date {
  const d = new Date(now);
  d.setHours(0, 0, 0, 0);
  d.setDate(d.getDate() - ((d.getDay() + 6) % 7));
  return d;
}

export function summarize(tickets: TicketCard[], now = new Date()) {
  const today = now.toISOString().slice(0, 10);
  const monday = weekStart(now);
  return {
    issues: tickets.filter((t) => t.col === 'issue' && !t.held_at).length,
    working: tickets.filter((t) => t.col === 'in_progress').length,
    late: tickets.filter((t) => t.col !== 'done' && t.due_date !== null && t.due_date < today).length,
    doneThisWeek: tickets.filter(
      (t) => t.col === 'done' && t.finished_at !== null && new Date(t.finished_at) >= monday,
    ).length,
  };
}

export function BoardSummary({ tickets }: { tickets: TicketCard[] }) {
  const s = summarize(tickets);
  const items = [
    { label: '새 이슈', value: s.issues, warn: false },
    { label: '작업 중', value: s.working, warn: false },
    { label: '마감 지남', value: s.late, warn: s.late > 0 },
    { label: '이번 주 완료', value: s.doneThisWeek, warn: false },
  ];
  return (
    <dl className="board-summary" aria-label="현황 요약">
      {items.map((item) => (
        <div key={item.label} className={item.warn ? 'is-warn' : item.value === 0 ? 'is-zero' : undefined}>
          <dt>{item.label}</dt>
          <dd className="tnum">{item.value}</dd>
        </div>
      ))}
    </dl>
  );
}
